const env = {
  api: process.env.VUE_APP_API,
  websocket: process.env.VUE_APP_REALTIME
}

export default env
